<template>
  <div id="user_active_vue">
    <el-table
      :data="tableData"
      style="width: 100%"
      class="fc-000000"
      empty-text="No active members found"
    >
      <el-table-column prop="firstname" label="Name" min-width="170" sortable>
        <template slot-scope="scope">
          <div class="fs-14 ellipsis">
            {{ scope.row.firstname }} {{ scope.row.lastname }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="email" label="Email Address" min-width="210" sortable>
        <template slot-scope="scope">
          <div class="fs-14 ellipsis">{{ scope.row.email }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="team_name" label="Team" min-width="150" sortable>
        <template slot-scope="scope">
          <div class="fs-14 ellipsis">{{ scope.row.team_name || "—" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="lastDate"
        label="Last activity"
        align="right"
        header-align="right"
        min-width="170"
        sortable
      >
        <template slot-scope="scope">
          <div class="fs-14">{{ activityLabel(scope.row) }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "userActive",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    activityLabel(member) {
      if (!member.lastDate) return "Not available";
      if (!member.time || member.time === "12:00 AM") return member.lastDate;
      return member.lastDate + " at " + member.time;
    },
  },
};
</script>

<style lang="scss">
#user_active_vue {
  min-width: 720px;

  .el-table tr,
  .el-table,
  .el-table th.el-table__cell {
    background-color: transparent;
  }

  .el-table th.el-table__cell {
    color: #777386;
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
}
</style>
